// 計測の差し替えの口。GA4 の測定 ID があれば GA4 へ、なければ手元の記録（window.__appfulEvents）だけ。
// 個人を特定する値（メール・名前・自由入力の文）は送らない。
import { config } from "./config";

export type Params = Record<string, string | number | boolean>;

export interface AnalyticsProvider {
  track(name: string, params: Params): void;
}

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    __appfulEvents?: { name: string; params: Params; at: number }[];
  }
}

function createGa4(id: string): AnalyticsProvider {
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.append(s);
  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function gtag() {
    // gtag は arguments のまま積む決まり
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag("js", new Date());
  // 一覧はページの移動を自分で扱うので、page_view は自分で送る。広告の個人化の信号は送らない。
  window.gtag("config", id, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
  return { track: (name, params) => window.gtag!("event", name, params) };
}

const local: AnalyticsProvider = {
  track(name, params) {
    (window.__appfulEvents ??= []).push({ name, params, at: Date.now() });
    if (window.__appfulEvents.length > 500) window.__appfulEvents.shift();
    if (import.meta.env.DEV) console.debug("[analytics]", name, params);
  },
};

const providers: AnalyticsProvider[] = [local];
if (config.ga4Id) providers.push(createGa4(config.ga4Id));

export function track(name: string, params: Params = {}) {
  for (const p of providers) {
    try {
      p.track(name, params);
    } catch (e) {
      console.error("[analytics] provider failed", e);
    }
  }
}
